module.exports = __webpack_public_path__ + "static/grandprize-prize-xbox-en-GB-d5b9b07db03e60425b148668f76bc8e0.png";